import { Component } from '@angular/core';

@Component({
    selector: 'app-scenarios',
    templateUrl: './scenarios.component.html',
    styleUrls: ['./scenarios.component.scss'],
})
export class ScenariosComponent {}
